import styles from "./_calendar-theme.module.css";

/** Visual contract for the booking calendar, shared by the booking sidebar and
 *  the dev matrix page so what gets reviewed is exactly what ships.
 *
 *  Cell WIDTH lives on `--cell-size`; cell HEIGHT is set by the calendar
 *  component itself (`--cell-h`), which needs the extra row for the price.
 *
 *  Desktop columns are 60px rather than the 52px they were before prices: a
 *  6–7 glyph amount ("$4,000", "$400K") rendered at 52px leaves barely a
 *  hairline between one date's price and the next one's, which reads as
 *  crowded on a fully-priced month even though nothing actually clips.
 *
 *  Mobile stays at 44px. It cannot grow — at 52px the popover was ~410px wide
 *  and clipped the Saturday column plus the next-month arrow on any phone
 *  under ~414px — and 44px is also Apple's minimum tap target. The price type
 *  scale absorbs the difference there instead. */
export const CALENDAR_SURFACE_CLASS = styles.surface;

/** Per-slot overrides on the `Calendar` primitive:
 *   - month / year label at 16px bold
 *   - prev / next chevrons as 40px circular buttons with a visible default
 *     treatment (border + panel background + subtle shadow) so they read as
 *     defined controls rather than transparent ghost icons
 *   - weekday header muted and tightened, so the price rows below carry the
 *     grid's visual weight instead of the header */
export const CALENDAR_SLOT_CLASSNAMES = {
  caption_label: styles.captionLabel,
  weekday: styles.weekday,
  button_previous: styles.navButton,
  button_next: styles.navButton,
};
